<template>
  <div :style="{ display: 'inline-flex', gap: '2px', padding: '3px', borderRadius: '9px', background: 'var(--p-overlay-popover-background)' }">
    <button
      v-for="[v, icon, label] in DENSITIES"
      :key="v"
      :title="label"
      :aria-label="label"
      :style="{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        height: '26px',
        padding: '0 11px',
        borderRadius: '7px',
        cursor: 'pointer',
        border: 0,
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 700,
        background: value === v ? 'var(--p-content-background)' : 'transparent',
        color: value === v ? 'var(--p-text-color)' : 'var(--p-surface-400)',
        boxShadow: value === v ? '0 1px 2px rgba(0,0,0,.18)' : 'none',
      }"
      @click="emit('change', v)"
    >
      <i :class="`pi pi-${icon}`" :style="{ fontSize: '12px' }" />{{ label }}
    </button>
  </div>
</template>

<script setup>
// List-view density toggle: Expanded cards vs Compact rows. Ported from
// collection-frame.
const DENSITIES = [
  ['expanded', 'id-card', 'Expanded'],
  ['compact', 'bars', 'Compact'],
]

defineProps({
  value: { type: String, default: 'expanded' },
})
const emit = defineEmits(['change'])
</script>
